module.exports = __webpack_public_path__ + "static/media/redlight.14df20a6.png";